import React from 'react';
import {observer} from 'mobx-react';
import SearchableDropdownSelect from 'shared/components/searchable_dropdown_select';

import _ from 'lodash';

const Signatures = observer(({uiState}) => {
  return (
    <SearchableDropdownSelect
      label='components.pdf.annotate.toolbar.Company Signatures'
      onSelect={signature => uiState.addAnnotation(signature, uiState.selectedAssignee)}
      options={uiState.signatures}
    />
  );
});

const MergeFields = observer(({uiState}) => {
  return (
    <SearchableDropdownSelect
      label={'components.pdf.annotate.toolbar.Employee Information'}
      onSelect={(field) => uiState.addAnnotation(field, uiState.selectedAssignee)}
      optionCategories={uiState.mergeFields}
    />
  );
});

const InputFields = observer(({uiState}) => {
  return (
    <SearchableDropdownSelect
      label='components.pdf.annotate.toolbar.Document Fields'
      onSelect={field => uiState.addAnnotation(field, uiState.selectedAssignee)}
      optionCategories={uiState.inputFields}
    />
  );
});

const Toolbar = observer(({uiState}) => {
  const {signatures} = uiState;

  return (
    <div className='flex align-items-middle relative mb3' style={{width: 798}}>
      <div className='mr2'>
        <MergeFields uiState={uiState}/>
      </div>
      <div>
        <InputFields uiState={uiState}/>
      </div>
      {!_.isEmpty(signatures) && <>
        <div className='border-right border--submarine mx2' style={{height: 30}}/>
        <div>
          <Signatures uiState={uiState}/>
        </div>
      </>}
    </div>
  );
});

export default Toolbar;
